import { Directive } from '@angular/core';

@Directive({
    selector: '[fi-items-list-after-wrapper]',
    standalone: false,
})
export class FiItemsListTranscludeDirective {}
